import script from "./ApplyTemplate.vue?vue&type=script&lang=ts&setup=true"
export * from "./ApplyTemplate.vue?vue&type=script&lang=ts&setup=true"

import "./ApplyTemplate.vue?vue&type=style&index=0&id=6c472901&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c472901"]])

export default __exports__